<div class="absolute -top-1 -right-1 pointer-events-none">
  <div class="w-3 h-3 bg-neutrals-white rounded-full absolute top-1 left-1"></div>
  <img [src]="images.routes.warningRoundFilled" class="relative w-5 h-5 filter-secondary-red" [alt]="label()" />
</div>
